(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const sectionSelector = '#MainContent > .shopify-section';
  const itemSelectors = [
    '.card-wrapper',
    '.collection-list__item',
    '.multicolumn-list__item',
    '.alade-card',
    '.alade-trust__item',
    '.alade-checks li',
    '.client-media-hero__content'
  ].join(',');

  const reveal = (element) => {
    element.classList.add('alade-entrance--visible');
    element.querySelectorAll('[data-alade-entrance]').forEach((child) => {
      child.classList.add('alade-entrance--visible');
    });
  };

  const prepareItems = (root) => {
    Array.from(root.querySelectorAll(itemSelectors)).forEach((element, index) => {
      if (element.hasAttribute('data-alade-entrance')) return;
      element.setAttribute('data-alade-entrance', '');
      element.style.setProperty('--alade-entrance-delay', `${Math.min(index * 80, 360)}ms`);
    });
  };

  const prepareSections = (root = document) => {
    const sections = Array.from(root.querySelectorAll(sectionSelector)).filter((section) => {
      return !section.hasAttribute('data-alade-section-entrance');
    });

    sections.forEach((section) => {
      section.setAttribute('data-alade-section-entrance', '');
      prepareItems(section);
    });

    return sections;
  };

  const boot = () => {
    const sections = prepareSections();

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      document.querySelectorAll('[data-alade-entrance]').forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.16
    });

    sections.forEach((section, index) => {
      if (index === 0 && section.getBoundingClientRect().top < window.innerHeight) {
        reveal(section);
        return;
      }

      observer.observe(section);
    });

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          prepareSections(node).forEach((section) => observer.observe(section));
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', (event) => {
      prepareSections(event.target).forEach((section) => observer.observe(section));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
